import React from 'react';
import styled from 'styled-components/macro';
import { Grid, TextField } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

export const DisplayOldToNew = props => {
  const { label, oldValue, newValue } = props;
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Grid container>
        <Grid item xs={5} lg={4} className="display-label">
          {t(label)}:
        </Grid>
        <Grid item xs={7} lg={8} className="display-values">
          <TextField
            value={oldValue}
            multiline
            InputProps={{
              readOnly: true,
              style: { fontSize: 12 },
            }}
          />
          <ArrowForwardIcon className="right-arrow" />
          <TextField
            value={newValue}
            multiline
            InputProps={{
              readOnly: true,
              style: { fontSize: 12 },
            }}
          />
        </Grid>
      </Grid>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  align-items: center;
  margin: 0 5px;
  .display-label {
    display: flex;
    align-items: center;
  }
  .display-values {
    display: flex;
    align-items: center;
    pointer-events: none;
  }
  .right-arrow {
    font-size: 18px;
  }
  .MuiFormControl-root {
    display: flex;
  }
`;
